import { Trans } from "@lingui/macro";
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import { UiBackdrop, UiButton, UiModuleLoader } from "@smp/ui";
import { IconWand } from "@tabler/icons-react";
import { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";
import { useQueryPolotnoTemplates } from "@/queries";
import { customGeneratePath } from "@/utils";

import classes from "./random_button.module.css";

export const RandomButton = () => {
  const navigate = useNavigate();

  const {
    state: { activeTemplateId, pathPattern, isRoutingDisabled },
    actions: { setActiveEntity },
  } = useContextPolotnoTemplates();

  const [isActive, setActive] = useState(false);

  const { isFetching, remove } = useQueryPolotnoTemplates(
    {
      page_size: 1,
      ordering: "?",
    },
    {
      enabled: isActive,
      onSuccess: (data) => {
        const tmpl = data.pages.at(0)?.results.at(0);

        if (tmpl) {
          if (!isRoutingDisabled) {
            navigate(
              customGeneratePath(pathPattern, {
                templateId: tmpl.id,
              }),
            );
          } else {
            setActiveEntity(String(tmpl.id));
          }
        }
      },
      onError: () => {
        setActive(false);
      },
    },
  );

  useIsomorphicLayoutEffect(() => {
    if (!activeTemplateId) {
      setActive(false);
      setTimeout(remove);
    }
  }, [activeTemplateId, remove]);

  return (
    <>
      <UiButton
        className={classes.button}
        startIcon={<IconWand />}
        onClick={() => setActive(true)}
        color="paper"
      >
        <Trans>Random template</Trans>
      </UiButton>

      {!import.meta.env.SSR &&
        createPortal(
          <UiBackdrop
            style={{
              zIndex: 999,
            }}
            open={isActive && isFetching}
          >
            <UiModuleLoader />
          </UiBackdrop>,
          document.body,
        )}
    </>
  );
};
